import { Receipt } from "lucide-react";
import { ExpenseReceipts } from "@/components/ExpenseReceipts";

export default function Expenses() {
  return (
    <div className="space-y-6" data-testid="employee-expenses-page">
      <header>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-[#1A2744] flex items-center gap-3">
          <Receipt className="h-8 w-8 text-[#C9A84C]" /> Expense Receipts
        </h1>
        <p className="text-gray-500 mt-1">
          Upload GST receipts for purchases — snap a photo, pick a category, and admin will review.
        </p>
      </header>
      <ExpenseReceipts />
    </div>
  );
}
